import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading text-primary-300 whitespace-nowrap">
              蜜桃少年漫画
            </Link>
            <p className="mt-3 text-sm text-secondary-300 leading-relaxed">
              蜜桃少年漫画提供漫画全集免费阅读下拉式体验，在线下拉浏览完整故事，享受免费且流畅的阅读乐趣。与土豪漫画网合作，为您带来最优质的漫画阅读服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/comic/mitao-shaonian" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">蜜桃少年</Link></li>
              <li><Link to="/comic/xingkong-qiyuan" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">星空奇缘</Link></li>
              <li><Link to="/comic/liehuo-shenjue" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">烈火神诀</Link></li>
              <li><Link to="/comic/jiuchong-tiangong" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">九重天宫</Link></li>
              <li><Link to="/comic/hua-yang-nianhua" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">花样年华</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-3">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">用户口碑</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; 2026 蜜桃少年漫画 版权所有 | 漫画全集免费阅读下拉式 - 土豪漫画网合作伙伴
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-300 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}